export const mergeUrl = (baseUrl: string = '', path: string = '') => {
  return baseUrl.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
};
